import script from "./clients-list-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./clients-list-modal.vue?vue&type=script&setup=true&lang=js"

import "./clients-list-modal.vue?vue&type=style&index=0&id=025c275c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025c275c"]])

export default __exports__